import React, { useState } from "react";
import axios from "axios";
import RejectionAlert from "./RejectionAlert";
import { Trans, withTranslation,useTranslation } from "react-i18next";

const UserDetails = ({ user, handleAlert }) => {
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [open, setOpen] = useState(false);
  const [attempt, setAttempt] = useState(0);

  const checkButtonDisable = () => {
    if (code.length >= 8 && code.length <= 10) {
      return false;
    } else {
      return true;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (user.acceptance_code == code || user.rejection_code == code) {
      return handleAlert(
        true,
        "Request failed",
        "Cannot send request to yourself",
        null,
        false
      );
    }
    const url = localStorage.getItem("api_url");
    const data = new FormData();
    data.set("sender_id", user.acceptance_code);
    data.set("receiver_id", code);

    axios({
      method: "post",
      url: `${url}send_match_request`,
      data: data,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const resp = res.data;
      console.log(resp);
      if (resp.status == "false") {
        handleAlert(true, "Request failed", resp.message, null, false);
        setCode("");
      } else {
        if (resp.attempt == 0) {
          handleAlert(
            true,
            "Request sent successfully",
            "The request to add friend successfully sent, Please wait till the the receiver's response",
            null,
            true
          );
        } else {
          setAttempt(resp.attempt);
          setOpen(true);
        }
        setCode("");
      }
    });
  };

  return (
    <>
      <form className="user-details-container small-mt" onSubmit={handleSubmit}>
        {/**Details */}
        <h3 className="heading-tertiary ">
          {" "}
          <Trans i18nKey="Hello">Hello</Trans> {user && user.user_name},
        </h3>
        <p className="paragraph gutter-bottom very-small-mt">
          <Trans i18nKey="Put the code of the user you want to connect to">
            Put the code of the user you want to connect to
          </Trans>
        </p>

        {/**INPUT */}
        <div className="req-form-group gutter-bottom amb15">
          <input
            type="text"
            id="code"
            className="req-input border-bottom"
            placeholder={t('entercode')}
            required
            value={code}
            minLength={8}
            maxLength={10}
            onChange={(e) => setCode(e.target.value)}
          />
        </div>

        {/**BUTTON Send */}
        <button
          className={`send-button ${
            !checkButtonDisable() ? "active-req" : "deactive-req"
          }`}
          type="submit"
          disabled={checkButtonDisable()}
        >
          <Trans i18nKey="Send">Send</Trans>
        </button>
        <RejectionAlert
          open={open}
          setOpen={setOpen}
          attempt={attempt}
          user={user}
        />
      </form>
    </>
  );
};

export default UserDetails;
